/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Operationhoursp22Inputs */



/**
* | output |
* | --- |
* | "Operation hours right/low pump" |
*
* @param {Br_History_Key_Operationhoursp22Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_operationhoursp22 = /** @type {((inputs?: Br_History_Key_Operationhoursp22Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Operationhoursp22Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Operation hours right/low pump")
	return /** @type {LocalizedString} */ ("Heures de fonctionnement pompe droite/basse")
});
export { br_history_key_operationhoursp22 as "br_history_key_operationHoursP2" }